export default __webpack_public_path__ + "shahbaz@2x.aa0bcd5e.png";